import { z } from 'zod';
import { FiniteNumberSchema } from '../../../../react-commons/components/inputs/text-fields/types';
import { IdSchema } from './baseSchemas';
import { msObject } from './msObject';

export enum ParamConstants {
    PARENT_ID_REQUEST_PARAM_NAME = 'parent-id',
    PARENT_RELATION_REQUEST_PARAM_NAME = 'parent-relation',
    INDEX_REQUEST_PARAM_NAME = 'index',
    DEPTH_REQUEST_PARAM_NAME = 'depth',
    UPDATE_VALIDATION_DEPTH_REQUEST_PARAM_NAME = 'validation-depth',
    SKIP_GLOBAL_VALIDATION_ON_LOCAL_ERROR = 'skip-global-validation-on-local-error',
    FILTER_REQUEST_PARAM_NAME = 'filter',
    PAGE_REQUEST_PARAM_NAME = 'page',
    PER_PAGE_REQUEST_PARAM_NAME = 'per-page',
    DELETION_STOP_ON_ERROR = 'stop-on-error',
    DELETION_ERROR_LEVEL = 'error-level',
    VERSIONED_IN = 'versioned-in',
    VERSIONED_IN_ARTIFACT_TYPE_GROUP = 'versioned-in-artifact-type-group',
    PRECEDING_VERSION_REQUEST_PARAM_NAME = 'preceding-version',
    PROJECT_ID = 'project-id',
    DATA_DICTIONARY_VARIANT_OBJECT = 'data-dictionary-variant-object',
    DATA_DICTIONARY_VALUE_SET = 'data-dictionary-value-set',
    VALIDATION_SCOPES = 'validation-scopes',
    DO_NOT_RETURN_EMPTY_RESULTS = 'no-empty-results',
}

export enum ValidationScopeType {
    NO_SCOPE = 'NO_SCOPE',
    SOFTWARE_COMPONENT_VERSION_MAPPING = 'SOFTWARE_COMPONENT_VERSION_MAPPING',
    COMPOSITION_VERSION_MAPPING = 'COMPOSITION_VERSION_MAPPING',
    PROJECT_LINE_VERSION = 'PROJECT_LINE_VERSION',
}

const ValidationScopeSchema = msObject({
    type: z.enum(ValidationScopeType),
    projectLineVersion: IdSchema.optional(),
    virtualProjectLines: z.array(IdSchema).nullish(),
});

const ValidationScopesSchema = msObject({
    validationScopes: z.array(ValidationScopeSchema),
});

export const CalculatedLimitsResourceSchema = msObject({
    calculationError: z.string().nullable(),
    upperLimit: FiniteNumberSchema.nullable(),
    lowerLimit: FiniteNumberSchema.nullable(),
});

export const CalculatedLimitsResponseSchema = z.record(z.string(), CalculatedLimitsResourceSchema);

export type ValidationScopes = z.infer<typeof ValidationScopesSchema>;
export type CalculatedLimitsResponse = z.infer<typeof CalculatedLimitsResponseSchema>;
export type CalculatedLimitsResource = z.infer<typeof CalculatedLimitsResourceSchema>;
